module.exports = (__webpack_require__(80542))(1972);